import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiUsuario } from "../../api/usuario";
import Swal from "sweetalert2";
import { estiloColores } from "../../estilos/colores";
import { ENTORNO } from "../../utils/constantes";

const apiusuario = new apiUsuario();

export function ReenviarCodigoActivacion() {
  const navigate = useNavigate();

  const navigateToActivarCuenta = () => {
    navigate(ENTORNO.URL_APLICACION + "/ActivarCuenta");
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await apiusuario.reenviarCodigoActivacion();

        Swal.fire({
          title: "",
          text: response.Mensaje,
          icon: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: estiloColores.Azul,
        }).then(function () {
          navigateToActivarCuenta();
        });
      } catch (error) {
        console.log(error);

        Swal.fire({
          title: "Error!",
          text: error.Mensaje,
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: estiloColores.Gris,
        });
      }
    })();
  });

  return <div className="ingresar"></div>;
}
